import React from "react";
import "../../styles/centralised-plan/layouts.css";

const CustomTable = ({ columns, data, isFirstColSticky = false }) => {
  return (
    <div className="table-responsive-k">
      <table className="custom-table-k">
        <thead className="table-header">
          <tr className="dark-bg-k">
            {columns.map((column, index) => (
              <th
                key={index}
                className={
                  index === 0 && isFirstColSticky ? "sticky-column" : ""
                }
              >
                {column?.text}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="table-body">
          {data &&
            data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((column, colIndex) => (
                  <td
                    key={colIndex}
                    className={
                      colIndex === 0 && isFirstColSticky ? "sticky-column" : ""
                    }
                  >
                    {column?.formatter
                      ? column?.formatter(row?.[column?.dataField], row)
                      : row?.[column?.dataField]}
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default CustomTable;
